/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const XPT800_CLAIM_OWNER_MUTATION = gql`
  mutation xpt800ClaimOwnerMutation($input: H2090ClaimOwnerInput!) {
    h2090ClaimOwner(input: $input) {
      h2090 {
        id
        serialNumber
        owners
      }
      clientMutationId
    }
  }
`;
